// key and corresponding midi note for that key
export const notes = [
  { key: "z", midiNumber: 48 },
  { key: "s", midiNumber: 49 },
  { key: "x", midiNumber: 50 },
  { key: "d", midiNumber: 51 },
  { key: "c", midiNumber: 52 },
  { key: "v", midiNumber: 53 },
  { key: "g", midiNumber: 54 },
  { key: "b", midiNumber: 55 },
  { key: "h", midiNumber: 56 },
  { key: "n", midiNumber: 57 },
  { key: "j", midiNumber: 58 },
  { key: "m", midiNumber: 59 },
  { key: "q", midiNumber: 60 },
  { key: "2", midiNumber: 61 },
  { key: "w", midiNumber: 62 },
  { key: "3", midiNumber: 63 },
  { key: "e", midiNumber: 64 },
  { key: "r", midiNumber: 65 },
  { key: "5", midiNumber: 66 },
  { key: "t", midiNumber: 67 },
  { key: "6", midiNumber: 68 },
  { key: "y", midiNumber: 69 },
  { key: "7", midiNumber: 70 },
  { key: "u", midiNumber: 71 },
  { key: "i", midiNumber: 72 },
];

// [midiNumber, frequency]
export const noteFrequencies = new Map([
  [12, 16.35],
  [13, 17.32],
  [14, 18.35],
  [15, 19.45],
  [16, 20.6],
  [17, 21.83],
  [18, 23.12],
  [19, 24.5],
  [20, 25.96],
  [21, 27.5],
  [22, 29.14],
  [23, 30.87],
  [24, 32.7],
  [25, 34.65],
  [26, 36.71],
  [27, 38.89],
  [28, 41.2],
  [29, 43.65],
  [30, 46.25],
  [31, 49.0],
  [32, 51.91],
  [33, 55.0],
  [34, 58.27],
  [35, 61.74],
  [36, 65.41],
  [37, 69.3],
  [38, 73.42],
  [39, 77.78],
  [40, 82.41],
  [41, 87.31],
  [42, 92.5],
  [43, 98.0],
  [44, 103.83],
  [45, 110.0],
  [46, 116.54],
  [47, 123.47],
  [48, 130.8],
  [49, 138.6],
  [50, 146.8],
  [51, 155.6],
  [52, 164.8],
  [53, 174.61],
  [54, 185],
  [55, 196],
  [56, 207.65],
  [57, 220],
  [58, 233.08],
  [59, 246.9],
  [60, 262],
  [61, 277.2],
  [62, 293.7],
  [63, 311.2],
  [64, 329.7],
  [65, 349.3],
  [66, 370.1],
  [67, 392.1],
  [68, 415.4],
  [69, 440],
  [70, 466.1],
  [71, 493.88],
  [72, 523.25],
  [73, 554.37],
  [74, 587.33],
  [75, 622.25],
  [76, 659.26],
  [77, 698.46],
  [78, 739.99],
  [79, 783.99],
  [80, 830.61],
  [81, 880.0],
  [82, 932.33],
  [83, 987.77],
  [84, 1046.5],
  [85, 1108.73],
  [86, 1174.66],
  [87, 1244.51],
  [88, 1318.51],
  [89, 1396.91],
  [90, 1479.98],
  [91, 1567.98],
  [92, 1661.22],
  [93, 1760.0],
  [94, 1864.66],
  [95, 1975.53],
  [96, 2093.0],
  [97, 2217.46],
  [98, 2349.32],
  [99, 2489.02],
  [100, 2637.02],
  [101, 2793.83],
  [102, 2959.96],
  [103, 3135.96],
  [104, 3322.44],
  [105, 3520.0],
  [106, 3729.31],
  [107, 3951.07],
  [108, 4186.01],
]);
